import RecordRTC from 'recordrtc';

// Function to set up screen and audio streams for recording
export const setScreenStream = async (recorderParams, videoRef, updateVideoStatus) => {
    let controller;
    // Check if CaptureController is available (Chrome-specific)
    if (typeof CaptureController !== 'undefined') {
        // Create a new CaptureController instance
        controller = new CaptureController();
    }
    // Define media parameters for screen capture
    const mediaParams = { audio: true, video: true, controller };
    // Flag to check if the webm MIME type is supported
    let webmMimeType = true;
    try {
        // Capture screen and system audio
        const screenRecorderStream = await navigator.mediaDevices.getDisplayMedia(mediaParams);
        // Get displaySurface value of the captured video track
        const [track] = screenRecorderStream.getVideoTracks();
        const displaySurface = track.getSettings().displaySurface;

        // Set focus behavior for CaptureController if displaySurface is "browser"
        if (displaySurface === 'browser' && controller) {
            controller.setFocusBehavior('no-focus-change');
        }
        // Capture microphone audio
        const microphoneStream = await navigator.mediaDevices.getUserMedia({ audio: true });
        // Create a new MediaStream with screen and microphone audio
        const combinedStream = new MediaStream();
        screenRecorderStream.getTracks().forEach((track) => combinedStream.addTrack(track));
        microphoneStream.getTracks().forEach((track) => combinedStream.addTrack(track));
        // Set the combined stream as the source for the video element
        if (videoRef.current) {
            videoRef.current.srcObject = combinedStream;
        }
        // Update video status to indicate recording countdown
        updateVideoStatus('recordingCountdown');
        // Determine the MIME type for recording based on browser support
        if (typeof window.MediaRecorder.isTypeSupported === 'function') {
            if (window.MediaRecorder.isTypeSupported('video/webm;codecs=vp9')) {
                recorderParams.mimeType = 'video/webm;codecs=vp9';
            } else if (window.MediaRecorder.isTypeSupported('video/webm;codecs=h264')) {
                recorderParams.mimeType = 'video/webm;codecs=h264';
            } else if (window.MediaRecorder.isTypeSupported('video/webm')) {
                recorderParams.mimeType = 'video/webm';
            } else if (window.MediaRecorder.isTypeSupported('video/mp4')) {
                recorderParams.mimeType = 'video/mp4';
                webmMimeType = false;
            }
        } else {
            // Test for webm support
            var testVideo = document.createElement('video');
            if (testVideo.canPlayType && testVideo.canPlayType('video/webm; codecs="vp8, vorbis"') !== '') {
                recorderParams.mimeType = 'video/webm';
                webmMimeType = true;
            } else {
                recorderParams.mimeType = 'video/mp4';
                webmMimeType = false;
            }
        }
        // Prepare the result object with necessary details
        const result = {
            screenRecorder: new RecordRTC(combinedStream, { type: recorderParams }),
            recorderParam: recorderParams,
            isScreenRecording: true,
            screenStream: combinedStream,
            webmMimeType,
        };

        return result;
    } catch (err) {
        // Log device error and update video status accordingly
        console.log('device error', err);
        updateVideoStatus('cameraDenied');
    }
};
